exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._3JXlRVeTqTZHm_KYaon7aM {\n  -webkit-backface-visibility: hidden;\n          backface-visibility: hidden;\n  position: absolute;\n  bottom: 10px;\n  right: 25px;\n  width: 70px;\n}\n\n.jBF1NDqx_3UffEFavqiB1 {\n  right: 20px;\n}\n\n._3lCjFCwcEtuAEhW46sXxMR {\n  right: 20px;\n}\n", ""]);

// exports
exports.locals = {
	"brandLogo": "_3JXlRVeTqTZHm_KYaon7aM",
	"bradesco-normal-black": "jBF1NDqx_3UffEFavqiB1",
	"bradesco-prime-black": "_3lCjFCwcEtuAEhW46sXxMR"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"importLoaders":1,"modules":true}!../node_modules/postcss-loader/lib?{"ident":"postcss"}!../node_modules/postcss-loader/lib?{"plugins":[null]}!./components/BrandLogo/style.css
// module id = 43
// module chunks = 0